import * as viewEvents from './viewEvents'

export default {
  viewEvents,
}
